module.exports = __webpack_public_path__ + "img/170-greece.030431b8.svg";